import { Routes, Route, Navigate } from 'react-router-dom';

import Oee from "./Oee"
import OeeMain  from './OeeMain';
import OeeLathe from './OeeLathe';
import OeeMilling from './OeeMilling';


const OEERealTimeData = () => {
  return (
    <div>
      <Routes>
        <Route path="/" element={<Navigate to="oee" replace />} />

        {/* Parent OPCUA route */}
        <Route path="oee" element={<OeeMain />}>
          {/* Default sub-route -> Ideal Digital Twin */}
          <Route index element={<Oee />} />

          {/* Nested Routes */}
          <Route path="oee-ideal-digital-twin" element={<Oee />} />
          <Route path="oee-lathe-machine" element={<OeeLathe />} />
          <Route path="oee-milling-machine" element={<OeeMilling/>} />
        </Route>
      </Routes>
    </div>
  );
};

export default OEERealTimeData;
